import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import { languages } from '../i18n';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

export const LanguageSelector = ({ variant = 'icon' }) => {
  const { language, setLanguage, t } = useLanguage();

  const currentLang = languages.find(l => l.code === language);

  if (variant === 'full') {
    return (
      <div className="space-y-2">
        <label className="text-sm theme-text-secondary">{t('settings.language')}</label>
        <div className="flex gap-2">
          {languages.map((lang) => (
            <Button
              key={lang.code}
              variant={language === lang.code ? 'default' : 'outline'}
              onClick={() => setLanguage(lang.code)}
              className={language === lang.code 
                ? 'bg-[#00d4ff] text-black hover:bg-[#00b8d4]' 
                : 'theme-border theme-text hover:theme-bg-card'}
            >
              <span className="mr-2">{lang.flag}</span>
              {lang.name}
            </Button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          data-testid="language-selector"
          className="theme-text-secondary hover:theme-text"
        >
          <Globe size={20} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="theme-bg-card theme-border" align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className={`cursor-pointer ${language === lang.code ? 'theme-accent' : 'theme-text'} hover:theme-bg-card`}
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
